import { Check, MessageCircle } from 'lucide-react';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';
import { CONTACT, SERVICES } from '../data/siteData';

export default function Experiences() {
  return (
    <>
      <Seo title="The Jonny’s Towing Experience" description="Jonny's Towing delivers relief, confidence and care—not just towing and roadside services." />
      <PageHero
        eyebrow="What we are really selling"
        title="Relief, confidence and care when you need it most."
        description="The service solves the vehicle problem. The experience is how we help you feel while it is being solved."
        image="/images/rolls-royce-flatbed.webp"
      />
      <section className="section container">
        <div className="experience-list">
          {SERVICES.slice(0, 7).map((service, index) => {
            const Icon = service.icon;
            return (
              <article className="experience-row" key={service.slug}>
                <span className="experience-number">{String(index + 1).padStart(2, '0')}</span>
                <span className="experience-icon"><Icon /></span>
                <div><h2>{service.title}</h2><p>{service.experience}</p></div>
              </article>
            );
          })}
        </div>
      </section>
      <section className="section section--dark">
        <div className="container feature-split">
          <img className="rounded-image" src="/images/flatbed-sunset.webp" alt="Jonny's Towing truck ready for service" />
          <div className="feature-copy">
            <span className="eyebrow">Why people remember it</span>
            <h2>Professional service, without feeling cold or transactional.</h2>
            <ul className="check-list">
              <li><Check /> Real humans who know the area and the work</li>
              <li><Check /> Fast, no-drama communication</li>
              <li><Check /> Unexpected kindness in a stressful moment</li>
              <li><Check /> Local loyalty and community involvement</li>
              <li><Check /> Five-star service as the standard</li>
            </ul>
            <a className="button button--primary" href={CONTACT.textHref}><MessageCircle size={18} /> Text HELP</a>
          </div>
        </div>
      </section>
    </>
  );
}
